import React, { useState } from "react";
import "./LoginStyle.scss";
import Logo from "../../../assets/images/home/new-logo.png";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../../services/firebase.Config";
import { useNavigate } from "react-router-dom";
import videoBg from "../../../assets/Movie/videoBg.mp4";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const onLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCrendential) => {
        const user = userCrendential.user;
        localStorage.setItem("isAuth", true);
        localStorage.setItem("userEmail", user.email);
        navigate("/home");
      })
      .catch((error) => {
        setErrorMsg("Usuário ou Senha Inválidos!");
        setTimeout(() => setErrorMsg(""), 9000);
        localStorage.setItem("isAuth", "false");
      });
  };

  return (
    <section id="login">
      <div className="container">
        <div className="wrapper">
          <div className="wrapper-form">
            <div className="wrapper-form-logo">
              <img src={Logo} alt="Logo" />
            </div>

            <form onSubmit={onLogin}>
              {errorMsg && (
                <label
                  id="error"
                  style={{
                    color: "Red",
                    background: "#ffffff94",
                    padding: "10px",
                    fontSize: "18px",
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: "10px",
                    margin: "5px 0 10px",
                  }}
                >
                  {errorMsg}
                </label>
              )}

              <input
                id="email"
                className={errorMsg ? "error-input" : ""}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Digite seu usuário"
                required
              />

              <input
                id="password"
                className={errorMsg ? "error-input" : ""}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Digite sua senha"
                required
              />

              <button className="btn" id="button" type="submit">
                <span>Entrar</span>
              </button>
            </form>
          </div>
        </div>
      </div>
      <video className="video_bg" loop muted autoPlay>
        <source src={videoBg} type="video/mp4" />
      </video>
    </section>
  );
};
export default Login;
